// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import messages from './zh_CN'  // 引入字典, 注意这里不能从 node_modules 读取,因为 webpack exclude了
import VeeValidate, {Validator} from 'vee-validate'

// Validator.updateDictionary({
// 	zh_CN: {
// 		messages
// 	}
// })
Vue.use(VeeValidate, {
	// errorBagName: 'veerrors', // change if property conflicts.
	fieldsBagName: 'veeFields',  // change if property conflicts.
	// locale: 'zh_CN',
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js